const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "gclid", "fbclid"];
const STORE = "vv_attribution";

export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  const fromUrl = Object.fromEntries(KEYS.map((k) => [k, (params.get(k) || "").slice(0, 300)]));
  const hasParams = KEYS.some((k) => fromUrl[k]);
  let stored = null;
  try { stored = JSON.parse(sessionStorage.getItem(STORE) || "null"); } catch { stored = null; }
  if (hasParams || !stored) {
    const data = { ...fromUrl, landing_page: window.location.href.slice(0, 1000), referrer: (document.referrer || "").slice(0, 1000) };
    try { sessionStorage.setItem(STORE, JSON.stringify(data)); } catch { /* storage unavailable */ }
  }
}

export function getAttribution() {
  let stored = {};
  try { stored = JSON.parse(sessionStorage.getItem(STORE) || "{}") || {}; } catch { stored = {}; }
  return Object.fromEntries([...KEYS, "landing_page", "referrer"].map((k) => [k, stored[k] || ""]));
}
